export const inputFormats = {
  audio: {
    maxBytes: 50 * 1024 * 1024,
  },
  image: {
    maxBytes: 10 * 1024 * 1024,
  },
  video: {
    maxBytes: 50 * 1024 * 1024,
  },
};
